import { PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';
import { schemaId, schemaTimestamp } from 'cpool-schemas';
import { z } from 'zod';

// Present on every processed notification regardless of kind.
const commonFields = {
    loanRequestId: schemaId,
    /** When the notification was processed (epoch millis = the processing event's timestamp). */
    processedAt: z.number(),
    userId: schemaId,
};

/**
 * One processed (handled) notification per user, loan request and kind. Discriminated on `kind`: only a
 * RESUBMISSION carries `resubmissionAt`, only a BANK_REPORT carries `subscriptionIdentifier`, a DOCUMENT
 * carries neither.
 */
export const ProcessedNotificationsTableDefinitionZod = z.discriminatedUnion('kind', [
    z.object({
        ...commonFields,
        kind: z.literal(PROCESSED_NOTIFICATION_KINDS.RESUBMISSION),
        /** The timestamp the resubmission was due. */
        resubmissionAt: z.number(),
    }),
    z.object({ ...commonFields, kind: z.literal(PROCESSED_NOTIFICATION_KINDS.DOCUMENT) }),
    z.object({
        ...commonFields,
        kind: z.literal(PROCESSED_NOTIFICATION_KINDS.BANK_REPORT),
        /** The consors subscription the notes belonged to. */
        subscriptionIdentifier: z.string(),
    }),
    z.object({
        ...commonFields,
        addedAt: schemaTimestamp,
        kind: z.literal(PROCESSED_NOTIFICATION_KINDS.ASSIGNED_USER_ADDED),
    }),
    z.object({
        ...commonFields,
        kind: z.literal(PROCESSED_NOTIFICATION_KINDS.ACTIVE_USER_SET),
        setAt: schemaTimestamp,
    }),
]);

export type ProcessedNotificationsTableSchema = z.infer<typeof ProcessedNotificationsTableDefinitionZod>;
